import Icon from './icon';

export * from './icon';
export default Icon;
